import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/login/1.jpg'
import _imports_1 from '@/assets/images/logo/logo.png'
import _imports_2 from '@/assets/images/logo/logo_dark.png'


const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = { class: "row m-0" }
const _hoisted_3 = { class: "col-xl-5 p-0" }
const _hoisted_4 = { class: "login-card login-dark" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = { class: "login-main" }
const _hoisted_7 = { class: "theme-form" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-input position-relative" }
const _hoisted_10 = ["type"]
const _hoisted_11 = { class: "social mt-4" }
const _hoisted_12 = { class: "btn-showcase" }
const _hoisted_13 = {
  class: "btn btn-light",
  href: "https://www.linkedin.com/login",
  target: "_blank"
}
const _hoisted_14 = {
  class: "btn btn-light",
  href: "https://twitter.com/login?lang=en",
  target: "_blank"
}
const _hoisted_15 = {
  class: "btn btn-light",
  href: "https://www.facebook.com/",
  target: "_blank"
}
const _hoisted_16 = { class: "mt-4 mb-0 text-center" }

import { ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'registerImageTwo',
  setup(__props) {

const type = ref<string>('password')
function showPassword() {
    if (type.value === 'password') {
        type.value = 'text';
    } else {
        type.value = 'password';
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "col-xl-7 p-0 b-center bg-size",
        style: _normalizeStyle({ backgroundImage: 'url(' + require('@/assets/images/login/1.jpg') + ')', })
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          class: "bg-img-cover bg-center d-none",
          src: _imports_0,
          alt: "looginpage"
        }, null, -1)
      ]), 4),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("a", _hoisted_5, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("img", {
                      class: "img-fluid for-light",
                      src: _imports_1,
                      alt: "looginpage"
                    }, null, -1),
                    _createElementVNode("img", {
                      class: "img-fluid for-dark",
                      src: _imports_2,
                      alt: "looginpage"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("form", _hoisted_7, [
                _cache[8] || (_cache[8] = _createStaticVNode("<h4>Create your account</h4><p>Enter your personal details to create account</p><div class=\"form-group\"><label class=\"col-form-label pt-0\">Your Name</label><div class=\"row g-2\"><div class=\"col-6\"><input class=\"form-control\" type=\"text\" required placeholder=\"First name\"></div><div class=\"col-6\"><input class=\"form-control\" type=\"text\" required placeholder=\"Last name\"></div></div></div><div class=\"form-group\"><label class=\"col-form-label\">Email Address</label><input class=\"form-control\" type=\"email\" required placeholder=\"Test@gmail.com\"></div>", 4)),
                _createElementVNode("div", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createElementVNode("label", { class: "col-form-label" }, "Password", -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("input", {
                      class: "form-control",
                      type: type.value,
                      name: "login[password]",
                      placeholder: "*********"
                    }, null, 8, _hoisted_10),
                    _createElementVNode("div", { class: "show-hide" }, [
                      _createElementVNode("span", {
                        class: "show",
                        onClick: showPassword
                      })
                    ])
                  ])
                ]),
                _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"form-group mb-0\"><div class=\"checkbox p-0\"><input id=\"checkbox1\" type=\"checkbox\"><label class=\"text-muted\" for=\"checkbox1\">Agree with<a class=\"ms-2\" href=\"#\">Privacy Policy</a></label></div><button class=\"btn btn-primary btn-block w-100\" type=\"submit\">Create Account</button></div><h6 class=\"text-muted mt-4 or\">Or signup with</h6>", 2)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("a", _hoisted_13, [
                      _createVNode(_component_vue_feather, {
                        class: "txt-linkedin",
                        type: "linkedin"
                      }),
                      _cache[3] || (_cache[3] = _createTextVNode(" LinkedIn "))
                    ]),
                    _createElementVNode("a", _hoisted_14, [
                      _createVNode(_component_vue_feather, {
                        class: "txt-twitter",
                        type: "twitter"
                      }),
                      _cache[4] || (_cache[4] = _createTextVNode(" twitter"))
                    ]),
                    _createElementVNode("a", _hoisted_15, [
                      _createVNode(_component_vue_feather, {
                        class: "txt-fb",
                        type: "facebook"
                      }),
                      _cache[5] || (_cache[5] = _createTextVNode(" facebook"))
                    ])
                  ])
                ]),
                _createElementVNode("p", _hoisted_16, [
                  _cache[7] || (_cache[7] = _createTextVNode("Already have an account?")),
                  _createVNode(_component_router_link, {
                    class: "ms-2",
                    to: "/auth/login"
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("Sign in")
                    ])),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})